<script type="text/javascript">
import FilterListTreeChild from "./FilterListTreeChild";
	 export default{
        name: 'FilterListTree',
        components: {
            FilterListTreeChild
        },
        props: {
            childs: Array,
            productcategories: Array,
            productid: Number,
            selectedcids: Array,
            category_data: {
                type: Array,
                default: () => [],
            }
        }, 
        beforeCreate(){
        
        //this.all_categories = this.$attrs.all_categories;
        },
        mounted(){
            if(this.category_data.length == 0){
            axios.get('/seller/product/categorytree').then(response => {
                     console.log(response);
                    this.all_categories = response.data;
                })
                this.clearCategories();
            }else{
                this.all_categories = this.category_data;
            }
            let self = this;
            //self.selectedids = self.selectedcids;
            this.$on('categories-cleared', function(){
               self.selectedids = [];
            })  
        },
        data: function() {
        return{
            all_categories: [],
            //product_categories: this.productcategories,
            activeIds: [],
            testObject:[],
            selectedids: [],
            selectedchildids: [],
            childitems: '',
            success: '',
            product_id: this.productid,
            showFilters: false,
            selectallbtn: 1,
        }
        },
        methods:{
            addToCategory(id){
                /*if(this.selectedids.length == 0){
                    this.selectedids[0] = id;
                }else{
                this.selectedids.push(id);
                }*/
                this.$emit('category-added', id);
            },
             findIds(id){
                this.testObject = [];
                this.testObject = this.selectedids.filter(item => item === id);
                    if(this.testObject.length){
                        return "checked";
                    }else{
                        return false;
                    }

                },
            clearCategories(){
                this.$emit('categories-cleared');
            },
            filterRecords(){
                this.$emit('filter-records');
            },
            selectAll(){
                this.selectallbtn = 0;
                this.$emit('check-all-categories');
            }
        },
        computed: {
            parentCategories(){
                return this.all_categories.filter(item => item.parent_id == null)
            },
        checkAll: {
            get: function () {
                return this.all_categories ? this.selectedids.length == this.all_categories.length : false;
            },
            set: function (value) {
                var selected = [];
                if (value) {
                    this.all_categories.forEach(function (data) {
                        selected.push(data.id);
                        this.$emit('category-added', data.id);
                    });
                }else{
                   // this.$emit('categories-cleared');
                }
                this.selectedids = selected;
            }
        }
    },

    }
</script>

<template>
    <div>
    <div class="card">
    <div class="card-body"><ul class="main-tree pl-0"><li v-for="category in all_categories" v-if="category.parent_id === null"><div class="custom-control custom-checkbox"><input type="checkbox" v-bind:value="category.id" v-on:click="addToCategory(category.id)" class="custom-control-input" v-bind:id="category.id"><label class="custom-control-label" v-bind:for="category.id">{{category.name}}</label></div><FilterListTreeChild :childs="category.childs" :all_categories="all_categories" :productcategories="productcategories" :productid="product_id" :selectedcids="selectedcids"></FilterListTreeChild></li></ul>

    <!--<div class="row"><div class="col-md-12"><h5>Active Categories</h5></div><div class="col-md-12"><ul class="list-group list-group-flush"><li class="list-group-item" v-for="selected in productcategories">{{selected.name}}</li></ul></div></div>-->
                <!--<b-form-checkbox v-model="checkAll" v-if="selectallbtn == 1" class="float-left" @click="selectAll()">Select All</b-form-checkbox>-->
             
</div>
</div>
 <a href="javascript:;" class="float-right" @click="clearCategories()">Clear</a>
 </div>
</template>